// Design tokens for the Settings screen, copied verbatim from the prototype so
// every size and colour has one source here rather than being retyped per file.
const tokens = {
  color: {
    green: '#29CC8B',
    greenDark: '#00A36A',
    greenSuccessDark: '#1C8D63',
    successLight: '#E9F9F3',
    red: '#FC5A5A',
    redLight: '#FFF2F4',
    redDark: '#C32130',
    amber: '#FFC542',
    amberDark: '#FFC800',
    amberLight: '#FFF9EC',
    textPrimary: '#000000',
    textSecondary: '#44444F',
    textDisabled: '#92929D',
    white: '#FFFFFF',
    surfacePage: '#FAFBFC',
    surfaceBand: '#F4F6F9',
    surfaceRowHover: '#FCFDFD',
    scrim: 'rgba(0,0,0,0.42)',
    border: '#E2E8EE',
  },
  // 850 "Heavy" in the prototype maps to the Avenir-bold face the app ships.
  fontBold: 'Avenir-bold',
  radius: { dialog: '12px', control: '10px', alert: '10px' },
  shadow: { dialog: '0 18px 44px rgba(42,55,74,0.28)' },
  duration: { base: '200ms', slow: '300ms' },
  ease: { standard: 'cubic-bezier(0.4,0,0.2,1)', out: 'cubic-bezier(0,0,0.2,1)' },
}

// Prototype keyframes, injected once via the components that use them.
export const keyframes = {
  '@keyframes settingsFade': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '@keyframes settingsPop': {
    from: { opacity: 0, transform: 'scale(0.96)' },
    to: { opacity: 1, transform: 'scale(1)' },
  },
  '@keyframes settingsSnack': {
    from: { opacity: 0, transform: 'translateY(14px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
}

export default tokens
